import styled from "styled-components";
import {Cell} from "./Cell";
import CompactPerformanceValue from "../../../../performance/CompactPerformanceValue";
import React from "react";
import {asLocalTime} from "../../../../../util/timeDescription";
import {useSelector} from "react-redux";
import {Clock} from "js-joda";

export const kpiWidth = 75;

const Container = styled(Cell)`
    flex-basis: ${kpiWidth + "px"};
    flex-direction: column;
    margin-right: 20px;
    align-items: flex-end;
    justify-content: center;
`;

const KpiTime = styled.div`
    color: #b6b6b6;
    font-size: 9px;
    text-align: right;
    margin-top: 0px;
`;

export const KpiCell = ({portfolioIdea}) => {
    const clock = useSelector(({clock}) => clock || Clock.systemDefaultZone());

    if (!portfolioIdea || !portfolioIdea.kpi) {
        return <Container className="t-kpi" />;
    }
    const kpiValue = portfolioIdea.kpiValue
                     ? <CompactPerformanceValue kpi={portfolioIdea.kpi} value={portfolioIdea.kpiValue} currency={portfolioIdea.kpiCurrency}/>
                     : <div>awaiting price</div>;
    const kpiTimestamp = (portfolioIdea.generatedAt && portfolioIdea.startPrice !== null)
                         ? <KpiTime className="t-kpi-timestamp">as at {asLocalTime(portfolioIdea.generatedAt, clock)}</KpiTime>
                         : null;
    return <Container className="t-kpi">
        {kpiValue}
        {kpiTimestamp}
    </Container>
};

const Header = styled(Container)`
    margin-right: 8px;
    font-size: 11px;
    font-weight: bold;
`;

export const KpiHeader = () => {
    return <Header>KPI</Header>
};